// Taktil tilbakemelding (vibrasjon) + EMCON (lys- og lyddisiplin). Vibrasjon på
// alarmer via Web Vibration API — men ALLTID undertrykt i EMCON-modus, som også
// demper lys/animasjon (via body.emcon-CSS) for felt-disiplin. Selvstendig modul:
// leser/skriver egen localStorage-tilstand, ingen main-wiring nødvendig.
const EMCON_KEY = 'skade.emcon';
let emcon = false;

/** Kall ved oppstart (setter body-klassen fra lagret tilstand). */
export function initEmcon(): void {
  emcon = localStorage.getItem(EMCON_KEY) === '1';
  document.body.classList.toggle('emcon', emcon);
}

export function isEmcon(): boolean { return emcon; }

export function setEmcon(on: boolean): void {
  emcon = on;
  try { localStorage.setItem(EMCON_KEY, on ? '1' : '0'); } catch { /* utilgjengelig */ }
  document.body.classList.toggle('emcon', on);
  if (on) { try { navigator.vibrate?.(0); } catch { /* stopp evt. pågående */ } }
}

/** Standard vibrasjonsmønstre (ms). */
export const HAPTIC = {
  tick: 20,
  alarm: [80, 40, 80],
  emergency: [200, 90, 200, 90, 300],
} as const;

/** Vibrer — men aldri i EMCON-modus (lyddisiplin) og aldri hvis ikke støttet. */
export function haptic(pattern: number | readonly number[]): void {
  if (emcon) return;
  try { navigator.vibrate?.(typeof pattern === 'number' ? pattern : [...pattern]); } catch { /* ikke støttet */ }
}
